"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slotTypeString = void 0;
exports.slotTypeString = Object.freeze({
    0: "シフト",
    2: "公休",
    3: "有休",
    5: "半有休",
    6: "法定休日",
    7: "法定外休日",
});
